import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AppSettingsService} from '../../services/app-settings.service';

@Component({
  selector: 'app-limited-integer-list-select',
  template: `
    <div class="form-group">
      <div class="col-12" style="margin-right: 1px !important;" *ngFor="let item of list | keyvalue">
        <div [ngClass]="listCount < 4 ? 'col-' + 12 / listCount : 'col-12'">
          <app-select-field
            [viewList]="viewList"
            [Group]="Group"
            [fieldName]="item.key"
            [fieldLabel]="settings.translateEnglish(item.key, translation)"
            [translation]="translation"
            [options]="item.value"
            (OnChange)="resetSubCount()"
          ></app-select-field>
        </div>
      </div>
      <div class="col-12" style="direction: rtl; text-align: right">
        <span [ngClass]="Group.controls.maxCount.invalid ? 'danger' : ''">تعداد کل {{subCount}} تعداد مجاز {{max}}</span>
      </div>
    </div>
  `,
  styleUrls: ['../../assets/css/light.theme.css'],
  styles: [`
    .danger {
      color: red;
    }
  `]
})
export class LimitedIntegerListSelectComponent implements OnInit, OnChanges {
  @Input() Group: FormGroup;
  @Input() required: boolean;
  @Input() questionEnglishName: string;
  @Input() viewList: any = {};
  @Input() max: number;
  @Input() translation: any = {};
  labelsList: string[] = [];
  list: any = {};
  listCount: number;
  subCount = 0;

  constructor(public settings: AppSettingsService) {
  }

  ngOnInit(): void {
    if (this.Group) {
      this.setLists(this.max);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.Group) {
      this.setLists(parseInt(this.max + '', 10));
    }
  }

  setLists(maxCount: number) {
    if (this.max) {
      this.setMaxCountValidator();
      this.labelsList = this.questionEnglishName.split('_');
      console.log('labelsList ', this.labelsList);
      this.labelsList.forEach(label => {
        if (!this.Group.controls[label]) {
          this.Group.addControl(label, new FormControl(''));
        }
        this.list[label] = [];
        for (let i = 0; i <= maxCount; i++) {
          this.list[label][i] = i;
        }
        console.log('label: ', this.list[label]);
      });
    }
  }

  setMaxCountValidator() {
    if (!this.Group.controls.maxCount) {
      this.Group.addControl('maxCount', new FormControl(''));
    }
    const validatorsList = [Validators.maxLength(this.max)];
    if (this.required) {
      validatorsList.push(Validators.required);
    }
    this.Group.controls.maxCount.setValidators(validatorsList);
  }

  resetSubCount() {
    this.subCount = 0;
    for (const listKey in this.list) {
      if (this.list.hasOwnProperty(listKey)) {
        if (this.Group.controls[listKey].value) {
          this.subCount += parseInt(this.Group.controls[listKey].value, 10);
        }
      }
    }
    this.Group.controls.maxCount.patchValue(this.subCount);
  }
}
